import React from 'react';
import { useTranslation } from 'react-i18next';

const SalesOrderStatus = ({ data }) => {
    const { t } = useTranslation();
    if (!data?.distribution?.length) return null;

    const strings = t('salesAnalytics.charts.orderStatus', { returnObjects: true });

    const STATUS_CONFIG = {
        pending:            { label: strings.statuses.pending,             color: '#f59e0b' },
        confirmed:          { label: strings.statuses.confirmed,           color: '#3b82f6' },
        in_transit:         { label: strings.statuses.in_transit,          color: '#06b6d4' },
        delivered:          { label: strings.statuses.delivered,           color: '#10b981' },
        invoiced:           { label: strings.statuses.invoiced,            color: '#8b5cf6' },
        cancelled:          { label: strings.statuses.cancelled,           color: '#ef4444' },
        delivery_assigned:  { label: strings.statuses.delivery_assigned,   color: '#f97316' },
        loading:            { label: strings.statuses.loading,             color: '#a78bfa' },
        loaded:             { label: strings.statuses.loaded,              color: '#0891b2' },
    };

    const total = data.total_orders || data.distribution.reduce((s, d) => s + d.count, 0);

    const sorted = [...data.distribution].sort((a, b) => b.count - a.count);

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.title}</span>
                    <div style={subtitleStyle}>{strings.subtitle.replace('{count}', total)}</div>
                </div>
            </div>

            {/* Stacked progress bar */}
            <div style={{ padding: '16px 20px 4px' }}>
                <div style={{ display: 'flex', height: 10, borderRadius: 8, overflow: 'hidden', gap: 1 }}>
                    {sorted.map(item => {
                        const cfg = STATUS_CONFIG[item.status] || { color: '#9ca3af' };
                        return (
                            <div
                                key={item.status}
                                title={`${item.status}: ${item.count}`}
                                style={{ flex: item.count, backgroundColor: cfg.color, minWidth: 2 }}
                            />
                        );
                    })}
                </div>
            </div>

            {/* Legend rows - 2 columns grid */}
            <div style={{ padding: '12px 20px 20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 8 }}>
                {sorted.map(item => {
                    const cfg = STATUS_CONFIG[item.status] || { label: item.status, color: '#9ca3af' };
                    return (
                        <div key={item.status} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 12px', borderRadius: 8, backgroundColor: '#f9fafb' }}>
                            <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: cfg.color, flexShrink: 0 }} />
                            <span style={{ fontSize: 13, color: '#374151', flex: 1, fontWeight: 500 }}>{cfg.label}</span>
                            <span style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{item.count}</span>
                            <span style={{ fontSize: 11, fontWeight: 600, color: cfg.color, backgroundColor: `${cfg.color}20`, borderRadius: 12, padding: '2px 8px', minWidth: 40, textAlign: 'center' }}>
                                {item.percentage?.toFixed(1)}%
                            </span>
                            <span style={{ fontSize: 11, color: '#9ca3af', minWidth: 70, textAlign: 'right' }}>
                                {parseFloat(item.total_weight_tons || 0).toFixed(2)} {strings.tonSuffix}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden' };
const headerStyle = { padding: '18px 20px 8px', borderBottom: '1px solid #f9fafb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };

export default SalesOrderStatus;
